"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynatraceTracker = void 0;
const tracker_1 = require("../tracker");
const dynatrace_1 = __importDefault(require("./dynatrace"));
class DynatraceTracker extends tracker_1.Tracker {
    constructor(config, reporterConfig) {
        super(config);
        this.id = 'dynatrace';
        this.initialize = (initializer) => {
            this.reporter.initialize(initializer);
        };
        this.sendInfo = (data) => {
            this.reporter.startTimedMetric(data, true);
        };
        this.log = (key, value, logLevel) => {
            this.reporter.log(key, value, logLevel);
        };
        this.exception = (exception, logSeverityLevel) => {
            this.reporter.exception(exception, logSeverityLevel);
        };
        this.recordBreadcrumb = (breadCrumb) => {
            this.reporter.recordBreadcrumb(breadCrumb);
        };
        this.setUserData = (user) => {
            this.reporter.setUserData(user);
        };
        this.stopTimedMetric = (timedMetric) => {
            return this.reporter.stopTimedMetric(timedMetric);
        };
        this.cancelTimedMetric = (timedMetric) => {
            return this.reporter.cancelTimedMetric(timedMetric);
        };
        this.reportData = (timedMetric, key, value) => {
            return this.reporter.reportData(timedMetric, key, value);
        };
        this.startTimedMetricWithParent = (timedMetric, overrideTimedMetric, attachToParent) => {
            return this.reporter.startTimedMetricWithParent(timedMetric, overrideTimedMetric, attachToParent);
        };
        this.traceSQLDatabaseRequest = (databaseInfo, startData) => {
            return this.reporter.traceSQLDatabaseRequest(databaseInfo, startData);
        };
        this.traceIncomingRemoteCall = (startData) => {
            return this.reporter.traceIncomingRemoteCall(startData);
        };
        this.traceOutgoingRemoteCall = (startData) => {
            return this.reporter.traceOutgoingRemoteCall(startData);
        };
        this.traceIncomingMessage = (startData) => {
            return this.reporter.traceIncomingMessage(startData);
        };
        this.traceOutgoingMessage = (startData) => {
            return this.reporter.traceOutgoingMessage(startData);
        };
        this.getTraceContextInfo = () => {
            return this.reporter.getTraceContextInfo();
        };
        this.getCurrentState = () => {
            return this.reporter.getCurrentState();
        };
        this.reporter = new dynatrace_1.default(reporterConfig);
    }
}
exports.DynatraceTracker = DynatraceTracker;
//# sourceMappingURL=dynatraceTracker.js.map